import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router";
import { useAuthStore } from "@/shared/stores/authStore";
import { Spinner } from "@bastion/ui";
import { LoginPage } from "@/pages/LoginPage";
import { AppErrorBoundary } from "./ErrorBoundary";
import { AuthenticatedRoutes } from "./routes";

export function App() {
  const { user, isLoading, initialize } = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    // On mount (including after OAuth redirect), Supabase detects the
    // OAuth code in the URL (detectSessionInUrl: true) and exchanges it
    // for a session. This works regardless of which port we're on.
    initialize();
  }, [initialize]);

  if (isLoading) {
    return (
      <div className="flex h-dvh items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!user) {
    return (
      <Routes>
        <Route path="*" element={<LoginPage />} />
      </Routes>
    );
  }

  return (
    <AppErrorBoundary resetKey={location.pathname}>
      <AuthenticatedRoutes />
    </AppErrorBoundary>
  );
}
